import type { IPlaceholderConfig, ITemplatePageConfig } from '~/types/template'

import { page4CommonBlocks, page4CommonPlaceholders } from './common'

import BackgroundImageBlock from '~/components/DynamicScreen/Blocks/BackgroundImage'
import ButtonBlock from '~/components/DynamicScreen/Blocks/Button'
import FrameBlock from '~/components/DynamicScreen/Blocks/Frame'
import TextBlock from '~/components/DynamicScreen/Blocks/Text'
import ToggleBlock from '~/components/DynamicScreen/Blocks/Toggle'
import ToggleBackgroundBlock from '~/components/DynamicScreen/Blocks/ToggleBackground'
import { EmptyBlock } from '~/components/DynamicScreen/utils'

const placeholders: IPlaceholderConfig[] = [
  {
    category: 'toggle',
    component: TextBlock,
    defaultValue: { color: '#2E2F31', translation: 'nb_days_free' },
    filters: ['eligible'],
    iapKey: 'iap_2',
    placeholderKey: 'toggle_txt_4b_1',
    type: ['color', 'translation'],
  },
  {
    category: 'toggle',
    component: TextBlock,
    defaultValue: { color: '#2E2F31', translation: 'nb_days_free' },
    filters: ['eligible'],
    iapKey: 'iap_2',
    placeholderKey: 'trial_txt_4b',
    type: ['color', 'translation'],
  },
  {
    category: 'toggle',
    component: TextBlock,
    defaultValue: { color: '#2E2F31', translation: 'carousel_price_per_subscription_period' },
    filters: ['eligible'],
    iapKey: 'iap_2',
    placeholderKey: 'price_txt_4b',
    type: ['color', 'translation'],
  },
  {
    category: 'button',
    className: 'button-text',
    component: TextBlock,
    defaultValue: { color: '#FFFFFF', translation: 'common.continue' },
    placeholderKey: 'buy_txt_4b',
    type: ['color', 'translation'],
  },
  {
    category: 'button',
    component: ButtonBlock,
    defaultValue: { color: '#2871FF' },
    placeholderKey: 'action_buy_cta_4b',
    type: 'color',
  },
  {
    category: 'toggle',
    component: ToggleBlock,
    defaultValue: { color: '#2871FF' },
    placeholderKey: 'action_variant_4b',
    type: 'color',
  },
  {
    category: 'toggle',
    component: TextBlock,
    defaultValue: { color: '#2E2F31' },
    filters: ['not_eligible'],
    iapKey: 'iap_2',
    placeholderKey: 'toggle_txt_4c_2',
    previewProperties: { text: 'Weekly billing activated' },
    type: ['color', 'translation'],
  },
  {
    category: 'toggle',
    component: TextBlock,
    defaultValue: { color: '#2E2F31' },
    filters: ['not_eligible'],
    iapKey: 'iap_2',
    placeholderKey: 'price_txt_4c_2',
    previewProperties: { text: '€49,99 per year' },
    type: ['color', 'translation'],
  },
  {
    category: 'in-app',
    component: EmptyBlock,
    placeholderKey: 'iap_2',
    type: 'iap',
  },
  {
    category: 'background',
    component: FrameBlock,
    defaultValue: { color: '#dbdbdb' },
    placeholderKey: 'toggle_shape_4b_border',
    type: 'color',
  },
  {
    category: 'background',
    component: ToggleBackgroundBlock,
    defaultValue: { color: '#ffffff' },
    placeholderKey: 'toggle_shape_4b_background',
    type: 'color',
  },
]

export const paywallPage4b: ITemplatePageConfig = {
  backgroundImage: 'background_img_4',
  blocks: page4CommonBlocks,
  className: 'page-4b',
  filters: ['eligible', 'not_eligible'],
  name: '4b. Paywall',
  placeholders: [
    ...page4CommonPlaceholders,
    ...placeholders,
    {
      category: 'background',
      component: BackgroundImageBlock,
      placeholderKey: 'background_img_4',
      type: 'asset',
    },
  ],
}

export const paywallPage4bVideo: ITemplatePageConfig = {
  ...paywallPage4b,
  backgroundImage: 'background_video_4',
  placeholders: [
    ...page4CommonPlaceholders,
    ...placeholders,
    {
      category: 'background',
      component: BackgroundImageBlock,
      placeholderKey: 'background_video_4',
      type: 'asset',
    },
  ],
}
